/**
 * @typedef {Object} businessParam  - 报表映射对象
 * @property {string} businessId - 业务（船舶事故、安全检查...）id
 * @property {string} businessType - 业务类型，与数据字典report_type_mapping相关：shipAccident
 * @property {string} templateId - 报表模板id，由businessType对应数据字典获取
 * @property {string} reportId - 报表id
 * @property {string} id - 实际id，为空时使用businessId
 * @property {Object} otherParams - 剩余参数，选择使用，可存放诸如shipCode等额外参数
 */
export default {
  state: {
    /**
     * 一个字符串的数组
     * @type {businessParam[]}
     */
    businessParams: [],
  },
  mutations: {
    emitBussiness(state, bussinessParam) {
      state.businessParams.push(bussinessParam)
    },
    setReportId(state, bussinessParam) {
      state.businessParams = state.businessParams.map((b) => {
        if (b.templateId === bussinessParam.templateId) {
          return { ...b, reportId: bussinessParam.reportId }
        }
        return b
      })
    },
    removeBussinessParam(state, businessId) {
      state.businessParams = state.businessParams.filter(
        (p) => p.businessId !== businessId,
      )
    },
    clearState(state) {
      state.businessParams = []
    },
  },
}
